import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      minHeight: '0',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',

      flex: 1,

      '& > div:first-child': {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '0',
        height: '100%',
        flex: 1,
        overflowY: 'auto',

        '& .MuiTypography-h4': {
          color: theme.palette.text.secondary,
          fontWeight: 500,
          margin: theme.spacing(1, 0, 2, 0),
        },
      },
    },
    container: {
      width: '100%',
      minHeight: 0,
      height: 'calc(100% - 7rem)',

      '& .MuiFormControl-root': {
        width: '100%',
        margin: 0,
      },

      '& .MuiGrid-item': {
        paddingRight: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',

        '&:last-child': {
          paddingTop: '2rem',
        },
      },

      '& .MuiGrid-spacing-xs-1': {
        margin: 0,
      },
    },
    button: {
      minHeight: '4rem',
      '& .MuiTypography-subtitle2': {
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
      },

      '& > button': {
        margin: '0',

        '& svg': {
          fontSize: '1.2rem',
        },
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),

      '& > button': {
        width: 'auto',
        height: 'auto',
        margin: '0',
        padding: '1rem 1.5rem',
        minWidth: '10rem',
      },
    },
  }),
)
